<form [formGroup]="schenkingFg">
        <snelstart-ui-date-form-control formControlName="datumSchenking"
                                        id="datumSchenking"
                                        label="Datum van de schenking"
                                        class="me-1 custom-input-250"
                                        [required]="true"
                                        (change)="saveForm()"
        >
        </snelstart-ui-date-form-control>
</form>

<div *ngIf="this.jaartalNietAkkkoord">
    <snelstart-ui-alert type="warning">
        Klopt de datum wel? Vul in deze aangifte Schenkbelasting {{ this.year }} alleen schenkingen in die gedaan zijn in {{ this.year ? this.year : 'het aangiftejaar' }}!
    </snelstart-ui-alert>
</div>

<div *ngIf="this.datumTeLaat">
    <snelstart-ui-alert type="warning">
        Klopt de datum wel? De datum van schenking kan niet in de toekomst liggen!
    </snelstart-ui-alert>
</div>

<form [formGroup]="objectFg">
    <snelstart-ui-select-form-control formControlName="objectSchenking"
                                      id="objectSchenking"
                                      label="Soort schenking"
                                      class="me-1 custom-input-250"
                                      [options]="this.optionsSchenking"
                                      [required]="true"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
</form>

<form [formGroup]="begiftigdeFg">
    <snelstart-ui-select-form-control formControlName="indicatieEerdereSchenking"
                                      id="indicatieEerdereSchenking"
                                      label="Eerste schenking dit aangiftejaar"
                                      class="me-1 custom-input-250"
                                      [required]="true"
                                      [options]="this.optionsJaNee"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
</form>

<form [formGroup]="schenkingFg">
    <snelstart-ui-select-form-control formControlName="relatieBegiftigdeMetSchenker"
                                      id="relatieBegiftigdeMetSchenker"
                                      label="Relatie ontvanger tot schenker"
                                      class="me-1 custom-input-250"
                                      [required]=true
                                      [options]="this.optionsRelatie"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
    <snelstart-ui-select-form-control formControlName="schenkerBetaaltDeSchenkbelasting"
                                      id="schenkerBetaaltDeSchenkbelasting"
                                      label="Wie betaalt de schenkbelasting "
                                      class="me-1 custom-input-250"
                                      [required]=true
                                      [options]="this.optionsWie"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
        <snelstart-ui-select-form-control formControlName="herroepelijkeSchenking"
                                          id="herroepelijkeSchenking"
                                          label="Onherroepelijke schenking"
                                          class="me-1 custom-input-250"
                                          [required]=true
                                          [options]="this.optionsOnherroepelijk"
                                          (change)="saveForm()"
        >
        </snelstart-ui-select-form-control>
</form>

<form [formGroup]="sbAangifteFg">
        <snelstart-ui-date-form-control formControlName="datumOndertekening"
                                        id="datumOndertekening"
                                        label="Datum ondertekening aangifte"
                                        class="me-1 custom-input-250"
                                        [required]="true"
                                        (change)="saveForm()"
        >
        </snelstart-ui-date-form-control>

    <div *ngIf="datumOndertekeningTeVroeg">
        <snelstart-ui-alert type="warning" [showIcon]="false">
            <b>Let op! </b>
            Klopt de datum wel? De datum van de ondertekening mag niet liggen voor de datum van de schenking.
        </snelstart-ui-alert>
    </div>
        <snelstart-ui-text-form-control formControlName="plaatsOndertekening"
                                        id="plaatsOndertekening"
                                        label="Plaats ondertekening aangifte"
                                        class="me-1 custom-input-250"
                                        [required]="true"
                                        (change)="saveForm()"
        >
        </snelstart-ui-text-form-control>
</form>
